import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import GrIcon from "./GrIcon";
import icons from "../icons";
import { tokens, gr } from "../tokens";

// Small status mark at the start of a list row (e.g. check-ins):
// done ✓ and open ◔ in brand teal, missed = soft red disc with a light red ring, upcoming = grey ring.
// Decorative by default (the row's status tag says it in words); pass `title` when it stands alone.
const ICON_MARKS = {
  done: icons.checkCircle,
  open: icons.clock,
};
const RINGS = {
  missed: { fill: gr.color.overdueSoft, stroke: gr.color.overdue, strokeOpacity: 0.4 },
  upcoming: { fill: "none", stroke: gr.color.muted, strokeOpacity: 1 },
};

export default function GrStatusMark({ status = "upcoming", size = "sm", title }) {
  if (ICON_MARKS[status]) {
    return (
      <Box component="span" sx={{ display: "inline-flex", flex: "none", color: gr.color.brand }}>
        <GrIcon icon={ICON_MARKS[status]} size={size} title={title} />
      </Box>
    );
  }
  const px = tokens.icon[size] || tokens.icon.sm;
  const ring = RINGS[status] || RINGS.upcoming;
  return (
    <Box
      component="svg"
      width={px}
      height={px}
      viewBox="0 0 16 16"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
      aria-label={title}
      sx={{ flex: "none", display: "block" }}
    >
      <circle cx="8" cy="8" r="6" strokeWidth="1.5" style={ring} />
    </Box>
  );
}

GrStatusMark.propTypes = {
  status: PropTypes.oneOf(["done", "open", "missed", "upcoming"]),
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  title: PropTypes.string,
};
